import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { API_URL } from 'src/app/app.contant';
import { AuthService } from '../../core/services/auth/auth.service';
import { ITEM_CATEGORY, ITEM_UNIT_LIST } from '../../pr-initiator/constants/pr-line-item-form-fields.constant';
import { IAPIResponse } from '../../shared/models';
import { ICompanyCodeResp, IDivisionDetailsResp, IDivisionResp, IFPACTIVESTATUS, IItracerRequest, IITracerUser, IUser, IUserResp } from '../models/admin.model';
import { EncryptionService } from '../../dashboard/services/encryption.service';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
    constructor(private http: HttpClient,
    private _authService : AuthService,
    private _encryptionService : EncryptionService) { }

  /*** Users ***/
  private reportingManagersSubject = new BehaviorSubject<any>(null);
  reportingManagers$ = this.reportingManagersSubject.asObservable();

  setReportingManagers(data: any): void {
    this.reportingManagersSubject.next(data);
  }

  public getUserById(userId : string) : Observable<IAPIResponse<IUserResp>> {
    return this.http.get<IAPIResponse<IUserResp>>(`${API_URL.ADMIN.USER}?id=${userId}`);
  }

  public getDivisionByDevisionName(divisionName : string) : Observable<IAPIResponse<IDivisionDetailsResp>> {
    return this.http.get<IAPIResponse<IDivisionDetailsResp>>(`${API_URL.ADMIN.GET_DIVISION}?division_name=${divisionName}`);
  }

  public getFPAprrovalStatus(company_code : string,purchase_org: string ) : Observable<IAPIResponse<IFPACTIVESTATUS>> {
    return this.http.get<IAPIResponse<IFPACTIVESTATUS>>(`${API_URL.ADMIN.CHECK_FP_APPROVAL}?company_code=${this._encryptionService.encryptPayload(company_code)}&purchase_org=${this._encryptionService.encryptPayload(purchase_org)}`);
  }

  public sendApproverFactoryProcurement(payload : any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.SEND_APPROVER}`, payload);
  }

  public getDivisionByDevisionNamePrId(divisionName : string,prId:any) : Observable<IAPIResponse<IDivisionDetailsResp>> {
    return this.http.get<IAPIResponse<IDivisionDetailsResp>>(`${API_URL.ADMIN.GET_DIVISION}?division_name=${this._encryptionService.encryptPayload(divisionName)}&prId=${this._encryptionService.encryptPayload(prId)}`);
  }

  public getUserByGId(gid:string,role:string|null) : Observable<IAPIResponse<IUserResp>> {
    return this.http.get<IAPIResponse<IUserResp>>(`${API_URL.ADMIN.USER_GID}?gid=${this._encryptionService.encryptPayload(gid)}&role=${this._encryptionService.encryptPayload(role)}`);
  }

  public getLoggedInUserProfile() : Observable<IAPIResponse<IUserResp>> {
    // const userId = this._authService.getUserId();
    const userDetails = this._authService.getUserDetails();
    return this.http.get<IAPIResponse<IUserResp>>(`${API_URL.ADMIN.USER}?id=${userDetails.id}`);
  }

  public getAdminUsers(active:string): Observable<IAPIResponse<IUserResp>> {
    return this.http.get<IAPIResponse<IUserResp>>(`${API_URL.ADMIN.USER}?active=${active}`);
  }

  public getAdminUserDetails(user_id : any): Observable<IAPIResponse<IUserResp>> {
    return this.http.get<IAPIResponse<IUserResp>>(`${API_URL.ADMIN.USER}?id=${user_id}`);
  }

  public createUser(user : IUserResp): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.USER}`, user);
  }

  public updateUser(user : IUserResp): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.UPDATE_USER}?id=${this._encryptionService.encryptPayload(user.users[0].user_id)}`, user);
  }

  /* Itracer user query API  */
  public getItacerUser(userRequest : IItracerRequest): Observable<IAPIResponse<IITracerUser[]>> {
    return this.http.post<IAPIResponse<IITracerUser[]>>(`${API_URL.ADMIN.ITRACER_USER}`, userRequest);
  }

  /*** Divisions ***/

  public getDivisions(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.DIVISION}`);
  }

  public createDivision(divisions : IDivisionResp): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.DIVISION}`, divisions);
  }

  public activateDeactivateUSer(payload : any): Observable<IAPIResponse<any>>{
    return this.http.post<IAPIResponse<any>>(`${API_URL.ACTIVATEDEACTIVATEUSER}`,payload)
  }

  public getBuyerDetailByPlantAndPurchaseGroup(plant_code:any, purchase_group:any): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.GET_BUYER_DETAILS_by_PLANT_AND_PURCHASE_GROUP}`);
  }

  /*** PO Confirm***/ 
  
  public updateVendorNotification(payload : any): Observable<IAPIResponse<any>>{
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.UPDATE_VENDOR_NOTIFICATION}`,payload)
  }

  public getVendorNotification(userId:any) : Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.GET_VENDOR_NOTIFICATION}`+userId);
  }


  /*** Plants  ***/

  public getPlant(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.PLANT_CODE}`);
  }
  
  public createPlantCode(plantCodes : IDivisionResp): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.PLANT_CODE}`, plantCodes);
  }

  /*** Company Codes  ***/

  public getCompanyCode(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.COMPANY_CODE}`);
  }

  public createCompanyCode(companyCodes : ICompanyCodeResp): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.COMPANY_CODE}`, companyCodes);
  }

  /*** ESN  ***/

  public getESNs(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.ESN}`);
  }

  public getCurrency(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.CURRENCY}`);
  }

  public createESN(companyCodes : any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.ESN}`, companyCodes);
  }

  public gettApproverData(): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.APPROVER}`,{});
  }

  public getThresholdData(): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.THRESHOLD}`,{});
  }

  public getReleaseStrategy(): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.RELEASESTRATEGY}`,{});
  }

  public createApprovers(companyCodes : any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.UPLOAD_APPROVER}`, companyCodes);
  }

  // qes GET

  public getQesMatrix(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.GET_QES_MASTER_APPROVER_DATA}`);
  }

  public getQesReleaseCode(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.GET_QES_RELEASE_CODE}`);
  }

  public getQesThreshold(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.GET_QES_THRESHOLD}`);
  }

  // qes upload
  public uploadQesMatrix(file:any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.GET_QES_MASTER_APPROVER_DATA}`,file);
  }

  public uploadQesReleaseCode(file:any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.GET_QES_RELEASE_CODE}`,file);
  }

  public uploadQesThreshold(file:any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.GET_QES_THRESHOLD}`,file);
  }

  
  public createThresold(companyCodes : any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.UPLOAD_THRESHOLD}`, companyCodes);
  }

  public createCurrency(file:any):Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.UPLOAD_CURRENCY}`, file);
  }

  public getCurrencyDetails(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.GET_CURRENCY}`);
  }

  public createPlantMaster(file:any):Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.UPLOAD_PLANTMASTER}`, file);
  }

  public getPlantMaster(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.GET_PLANTMASTER}`);
  }

  public createPoCOnfirmationVendorMaster(file:any):Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.UPDATE_VENDOR_NOTIFICATION}`, file);
  }

  public getPoConfirmationVendorMaster(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.GET_VENDOR_NOTIFICATION}`);
  }

  public createReleaseStrategy(companyCodes : any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.UPLOAD_RELEASESTRATEGY}`, companyCodes);
  }
    /*** ESN Service ***/

  public createEsnService(file:any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.ESN_SERVICE}`, file);
  }

  public getEsnService(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.ESN_SERVICE}`);
  }
  /*** Payment term key**/

  public createPaymentTermKey(file:any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.PAYMENT_TERM_KEY}`, file);
  }

  public getPaymentTermKey(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.PAYMENT_TERM_KEY}`);
  }

//EHS

public uploadEHSdata(file:any):Observable<IAPIResponse<any>>{
  return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.EHS_UPLOAD}`, file);
}

public getEHSdata(): Observable<IAPIResponse<any>> {
  return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.EHS_UPLOAD}`);
}
// EHS

public getYApartner(): Observable<IAPIResponse<any>> {
  return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.YA_PARTNER}`)
}

public uploadYApartner(file:any):Observable<IAPIResponse<any>>{
  return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.YA_PARTNER}`, file);
}

public getConfControlr(): Observable<IAPIResponse<any>> {
  return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.CONF_CONTROL}`)
}

public uploadConfControl(file:any):Observable<IAPIResponse<any>>{
  return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.CONF_CONTROL}`, file);
}

public getPackingCode(): Observable<IAPIResponse<any>> {
  return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.PACKING_CODE}`)
}

public uploadPackingCode(file:any):Observable<IAPIResponse<any>>{
  return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.PACKING_CODE}`, file);
}

public getPartnerCode(): Observable<IAPIResponse<any>> {
  return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.PARTNER_CODE}`)
}

public uploadPartnerCode(file:any):Observable<IAPIResponse<any>>{
  return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.PARTNER_CODE}`, file);
}
public getShippingCode(): Observable<IAPIResponse<any>> {
  return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.SHIPPING_CODE}`)
}

public uploadShippingCode(file:any):Observable<IAPIResponse<any>>{
  return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.SHIPPING_CODE}`, file);
}
// =============
public getTAXCode(): Observable<IAPIResponse<any>> {
  return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.TAX_CODE}`)
}

public uploadTAXCode(file:any):Observable<IAPIResponse<any>>{
  return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.TAX_CODE}`, file);
}

public getCONDTYPE(): Observable<IAPIResponse<any>> {
  return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.COND_TYPE}`)
}

public uploadCONDTYPE(file:any):Observable<IAPIResponse<any>>{
  return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.COND_TYPE}`, file);
}
public getGBK(): Observable<IAPIResponse<any>> {
  return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.GBK}`)
}

public uploadGBK(file:any):Observable<IAPIResponse<any>>{
  return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.GBK}`, file);
}
public getClause(): Observable<IAPIResponse<any>> {
  return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.CLAUSE}`)
}

public uploadClause(file:any):Observable<IAPIResponse<any>>{
  return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.CLAUSE}`, file);
}
public getDocType(): Observable<IAPIResponse<any>> {
  return this.http.get<IAPIResponse<any>>(`${API_URL.ADMIN.DOC_TYPE}`)
}

public uploadDocType(file:any):Observable<IAPIResponse<any>>{
  return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.DOC_TYPE}`, file);
}

  public getItemCategories() : Observable<IAPIResponse<any>> {
    const data = [...ITEM_CATEGORY]
    const response = {
      data,
      exception : "",
      message :  "",
      status : 200
    }
    return of(response);
  }

  public getItemUnits() : Observable<IAPIResponse<any>> {
    const data = [...ITEM_UNIT_LIST]
    const response = {
      data,
      exception : "",
      message :  "",
      status : 200
    }
    return of(response);
  }

  /*** ACCOUNT ASSIGNMENT CATEGORY  ***/

  public getAccountAssignmentCategories(): Observable<IAPIResponse<any>> {
    const data = [
      { acc_assignment_category : " - " },
      { acc_assignment_category : "0-Intra company bus" },
      { acc_assignment_category : "1-ICB SDI" },
      { acc_assignment_category : "2-ICB-Services/Stat.GR" },
      { acc_assignment_category : "3-Project GR/no IR" },
      { acc_assignment_category : "4-All acct. transport." },
      { acc_assignment_category : "5-Text no GR/no IR" },
      { acc_assignment_category : "6-Stat. GR/IR" },
      { acc_assignment_category : "7-Stat. GR/no IR" },
      { acc_assignment_category : "8-Project no GR/IR" },
      { acc_assignment_category : "9-Faultrepair Order" },
      { acc_assignment_category : "A-Asset" },
      { acc_assignment_category : "B-MTS prod./sales ord." },
      { acc_assignment_category : "C-Sales order" },
      { acc_assignment_category : "D-Indiv.cust./project" },
      { acc_assignment_category : "E-Ind. cust. w. KD-CO" },
      { acc_assignment_category : "F-Order" },
      { acc_assignment_category : "G-MTS prod./project" },
      { acc_assignment_category : "K-Cost center" },
      { acc_assignment_category : "N-Network" },
      { acc_assignment_category : "P-Project" },
      { acc_assignment_category : "Q-Proj. make-to-order" },
      { acc_assignment_category : "T-All new aux.acc.ass." },
      { acc_assignment_category : "U-Unknown" },
      { acc_assignment_category : "X-All aux.acct.assgts." },
      { acc_assignment_category : "Z-Project No GR/ W IR" }
    ]
    const response = {
      data,
      exception : "",
      message :  "",
      status : 200
    }
    return of(response);
  }
  public getWbsElementBalance(acc_assignment_value:any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.ADMIN.WBSELEMENTBALANCE}`,acc_assignment_value);
  }
  public uploadQESmatrix(file:any): Observable<IAPIResponse<any>>{
    return this.http.post<IAPIResponse<any>>(`${API_URL.QES_MATRIX}`,file)
  }

  public fetchQESmatrix(): Observable<IAPIResponse<any>>{
    return this.http.get<IAPIResponse<any>>(`${API_URL.QES_MATRIX}`)
  }

  public getServiceMaterialDesc(): Observable<IAPIResponse<any>>{
    return this.http.get<IAPIResponse<any>>(`${API_URL.SERVICE_MATERIAL_DESC}`)
  }

  public uploadServiceMaterialDesc(file:any): Observable<IAPIResponse<any>>{
    return this.http.post<IAPIResponse<any>>(`${API_URL.SERVICE_MATERIAL_DESC}`,file)
  }
  public getGLAccountMasterData(): Observable<IAPIResponse<any>>{
    return this.http.get<IAPIResponse<any>>(`${API_URL.GL_ACCOUNT_MASTER}`)
  }

  public uploadGLAccountMasterData(file:any): Observable<IAPIResponse<any>>{
    return this.http.post<IAPIResponse<any>>(`${API_URL.GL_ACCOUNT_MASTER}`,file)
  }
  public getCostCenterMasterData(): Observable<IAPIResponse<any>>{
    return this.http.get<IAPIResponse<any>>(`${API_URL.COST_CENTER_MASTER}`)
  }

  public uploadCostCenterMasterData(file:any): Observable<IAPIResponse<any>>{
    return this.http.post<IAPIResponse<any>>(`${API_URL.COST_CENTER_MASTER}`,file)
  }

  public getReportingManagerDtails(): Observable<IAPIResponse<any>>{
    return this.http.get<IAPIResponse<any>>(`${API_URL.REPORTING_MANAGER_DETAIL_MASTERDATA}`)
  }

  public uploadReportingManagerDtails(file:any): Observable<IAPIResponse<any>>{
    return this.http.post<IAPIResponse<any>>(`${API_URL.REPORTING_MANAGER_DETAIL_MASTERDATA}`,file)
  }

  public mapGLAccount(user: IUser, GLAccounts: any[]): Observable<IAPIResponse<any>> {
    let payload = {
      "user_id": user.user_id,
      "role": user.role,
      "gid": user.gid,
      "gl_account_codes": GLAccounts
    }
    return this.http.post<IAPIResponse<any>>(`${API_URL.GL_ACCOUNT_MAPPING}`, payload)
  }

  public mapCostCenter(user: IUser, costCenters: any[]): Observable<IAPIResponse<any>> {
    let payload = {
      "user_id": user.user_id,
      "role": user.role,
      "gid": user.gid,
      "cost_center_codes": costCenters
    }
    return this.http.post<IAPIResponse<any>>(`${API_URL.COST_CENTER_MAPPING}`, payload)
  }

  public getMappedGLAccountsById(id: any): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.FETCH_MAPPED_GL_ACCOUNTS + id}`, {})
  }

  public getMappedCostCenterById(id: any): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.FETCH_MAPPED_COST_CENTER + id}`, {})
  }

  public getMappedGLAccountsByRole(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.GL_ACCOUNT_MASTER}`, {})
  }

  public fetchAuditReport(payload:any):Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.GET_AUDIT_REPORT}`,payload)
  }
}
